(function() {
  'use strict';

  angular.module('epf.layout')
    .component('mainTemplate', {
      templateUrl: 'app/layout/templates/main.html',
      transclude: true
    })
    .component('twoColumnsRightTemplate', {
      templateUrl: 'app/layout/templates/2-columns-right.html',
      transclude: true
    })
    .component('oneColumnFullTemplate', {
      templateUrl: 'app/layout/templates/1-column-full.html',
      transclude: true
    });
})();
